import { Pipe, PipeTransform } from '@angular/core';
import { LogModelEnum } from '../enums/log-model.enum';
import { ScenarioItemSubType } from '../enums/scenario-Item-sub-type.enum';

@Pipe({
  name: 'filterLog',
  standalone: false,
})
export class FilterLogPipe implements PipeTransform {
  transform(
    value: Array<any>,
    params: { param: string; key?: number | string }
  ): any[] {
    return value.filter((el) => {
      if (el.model === LogModelEnum.ITEM) {
        if (el.subType !== ScenarioItemSubType.MULTI_CHOICE) {
          el.results = el.results.filter(
            (res) => res.user?.is_loggist === params.key
          );
          return el;
        }
      } else if (el.user.is_loggist === params.key) {
        return el;
      }
    });
  }
}
